module.exports = "<ui-gmap-marker [marker]=$ctrl.marker></ui-gmap-marker> ";